module.exports = __webpack_public_path__ + "static/media/monet-11.e312df29.jpeg";